export default {
  // Navbar
  nav: {
    howItWorks: 'Comment ça marche',
    newUpload: 'Nouvel import',
    signInSave: 'Se connecter',
    upload: 'Importer',
    files: 'Fichiers',
    account: 'Compte',
    signOut: 'Se déconnecter',
    pricing: 'Tarifs',
    legal: 'Mentions légales',
    goToApp: 'Ouvrir l’app',
    signInGoogle: 'Se connecter avec Google',
  },

  // Landing
  landing: {
    formatsTitle: 'Ouvre 70 types de fichiers',
    formatsLink: 'Voir tous les formats',
    eyebrow: 'Visionneuse 3D pour Revit, IFC, STEP et 70 types de fichiers',
    ctaUpload: 'Nouvel import',
    ctaNoAccount: 'Essai sans inscription',
    viewerCaption: 'Maquette IFC en direct · faites glisser pour pivoter',
    heroTitle1: 'Partage de fichiers BIM.',
    heroTitle2: 'Simple et rapide.',
    heroSubtitle: 'Ouvrez Revit, IFC, STEP, Tekla, Rhino, DXF, OBJ, FBX, STL et bien d’autres fichiers 3D dans le navigateur. Partagez-les par lien ou intégrez la visionneuse à votre site.',
    heroFree: 'Gratuit — 10 fichiers par mois',
    footerRights: 'Tous droits réservés.',
  },

  // Upload
  upload: {
    bundled: '{count} fichiers regroupés dans {name}',
    bundleHint: 'Maquette avec matériaux ou textures (OBJ + MTL, DAE, 3DS…) ? Déposez le dossier entier ou un ZIP.',
    guestNotice: 'Mode invité : jusqu’à {limit} fichiers. Connectez-vous pour les conserver et partager des liens.',
    openViewer: 'Ouvrir la visionneuse',
    title: 'Importer des fichiers',
    uploadsThisMonth: 'imports ce mois-ci',
    remaining: 'restants',
    dragDrop: 'Glissez-déposez vos fichiers ici',
    orClick: 'ou cliquez pour parcourir',
    formats: 'IFC, DWG, PDF, DXF, BCF, GLTF, GLB, OBJ, FBX, DAE, STL, 3MF, PLY, USDZ et tout autre type de fichier',
    limitReached: 'Limite mensuelle atteinte',
    limitReachedDesc: 'Vous avez utilisé vos {limit} imports de ce mois.',
    upgradePro: 'Passer à Pro →',
    uploading: 'Import en cours...',
    uploadComplete: 'Import terminé !',
    filesUploaded: '{count} fichier(s) importé(s) avec succès.',
    viewMyFiles: 'Voir mes fichiers',
    uploadMore: 'Importer d’autres fichiers',
    uploadFailed: 'Échec de l’import',
    tryAgain: 'Réessayer',
    limitError: 'Limite mensuelle d’imports atteinte. Passez à Pro pour importer davantage.',
    partialUpload: 'Vous ne pouvez importer que {max} fichier(s) de plus ce mois-ci. Import des {max} premiers.',
    fileTooLarge: '« {name} » dépasse la taille maximale de {limit} de votre forfait. Passez à Pro pour des fichiers plus volumineux.',
  },

  // Files
  files: {
    title: 'Mes fichiers',
    uploadFiles: 'Importer des fichiers',
    loading: 'Chargement de vos fichiers...',
    noFiles: 'Aucun fichier pour le moment',
    noFilesDesc: 'Importez votre premier fichier pour commencer.',
  },

  // Account
  account: {
    title: 'Compte',
    profile: 'Profil',
    userId: 'ID utilisateur',
    authProvider: 'Fournisseur d’authentification',
    subscription: 'Abonnement',
    currentPlan: 'Forfait actuel',
    monthlyLimit: 'Limite mensuelle d’imports',
    price: 'Prix',
    free: 'Gratuit',
    filesPerMonth: '{count} fichiers / mois',
    unlimited: 'Illimité',
    freeForever: '0 € / à vie',
    custom: 'Sur mesure',
    viewPlans: 'Voir les forfaits →',
    upgradeToPro: 'Passer à Pro',
    manageSubscription: 'Gérer l’abonnement',
    processing: 'Traitement...',
    usageTitle: 'Utilisation ce mois-ci',
    filesUploaded: 'fichiers importés ce mois-ci',
    unlimitedRemaining: 'Imports illimités',
    uploadsRemaining: '{count} import(s) restant(s) ce mois-ci',
    limitReached: 'Limite mensuelle atteinte. Réinitialisation le mois prochain.',
    session: 'Session',
    signOutDesc: 'Déconnectez-vous de votre compte sur cet appareil.',
    signOut: 'Se déconnecter',
  },

  // Account: Claude / MCP API keys
  mcp: {
    title: 'Claude (MCP)',
    serverUrl: 'URL du serveur MCP',
    desc: 'Utilisez BimDrop depuis Claude : demandez-lui d’envoyer des fichiers, de les lister et de créer des liens de partage.',
    keyName: 'Nom de la clé',
    keyNamePlaceholder: 'Nom de la clé, ex. Claude Code',
    create: 'Créer une clé',
    newKeyWarning: 'Copiez cette clé maintenant. Elle ne sera plus affichée.',
    claudeCode: 'Claude Code',
    otherClients: 'Autres clients MCP (configuration JSON)',
    copy: 'Copier',
    copied: 'Copié',
    created: 'créée le {date}',
    lastUsed: 'utilisée le {date}',
    neverUsed: 'jamais utilisée',
    revoke: 'Révoquer la clé',
    revokeConfirm: 'Révoquer « {name} » ? Claude perdra l’accès avec cette clé.',
    error: 'Une erreur est survenue. Réessayez.',
    claudeApps: 'claude.ai et Claude Desktop',
    claudeAppsSteps: 'Allez dans Paramètres → Connecteurs → Ajouter un connecteur personnalisé, collez l’URL ci-dessus et connectez-vous avec Google.',
    claudeCodeSteps: 'Lancez ensuite /mcp dans Claude Code et connectez-vous avec Google.',
    connectedApps: 'Applications connectées',
    connected: 'connectée le {date}',
    disconnect: 'Déconnecter',
    disconnectConfirm: 'Déconnecter « {name} » ? Elle perdra l’accès à vos fichiers.',
    apiKeys: 'Clés API',
    apiKeysDesc: 'Pour les scripts et les clients MCP sans connexion. Envoyez la clé dans « Authorization: Bearer … ».',
  },

  // OAuth consent page (Claude connectors)
  oauth: {
    loading: 'Vérification de la demande…',
    invalid: 'Cette demande de connexion n’est pas valide',
    error: 'Une erreur est survenue. Réessayez.',
    title: 'Autoriser {app} à accéder à votre compte BimDrop ?',
    unverified: 'BimDrop n’a pas vérifié cette application. Continuez seulement si vous lui faites confiance.',
    signInPrompt: 'Connectez-vous pour continuer.',
    signedInAs: 'Connecté en tant que {email}.',
    switchAccount: 'Utiliser un autre compte',
    permissionsTitle: 'Elle pourra :',
    permUpload: 'Envoyer des fichiers sur votre compte',
    permList: 'Voir vos fichiers et leurs liens',
    permShare: 'Créer et révoquer des liens de partage',
    redirectNote: 'Après autorisation, vous reviendrez sur {host}.',
    allow: 'Autoriser',
    deny: 'Annuler',
    redirecting: 'Retour vers {host}…',
  },

  // Viewer
  viewer: {
    loadingModel: 'Chargement de la maquette 3D…',
    loadError: 'Impossible de charger la maquette',
    back: 'Retour',
    fitView: 'Recadrer la vue',
    projection: 'Projection',
    hideSelected: 'Masquer l’élément sélectionné',
    isolateSelected: 'Isoler l’élément sélectionné',
    showAll: 'Afficher tous les éléments',
    share: 'Partager',
    loading: 'Chargement du fichier...',
    processingBtlx: 'Traitement du BTLx...',
    backToFiles: 'Retour aux fichiers',
    notPreviewable: 'Ce type de fichier ne peut pas être prévisualisé.',
    btlxProcessing: 'La maquette 3D est en cours de génération. Patientez un instant puis actualisez la page.',
    btlxError: 'Échec du traitement. La maquette 3D n’a pas pu être générée.',
    btlxQueued: 'La maquette 3D est en file d’attente. Revenez dans quelques instants.',
    parts: 'pièces',
    layers: 'calques',
  },

  // Shared Viewer
  shared: {
    loading: 'Chargement de la maquette partagée...',
    linkNotFound: 'Lien introuvable',
    linkExpired: 'Ce lien de partage n’existe pas ou a expiré.',
    goToBimdrop: 'Aller sur Bimdrop',
    sharedVia: 'Ce fichier a été partagé avec vous via Bimdrop.',
    download: 'Télécharger',
    tryFree: 'Essayer Bimdrop gratuitement →',
    hideSelected: 'Masquer la sélection',
    isolateSelected: 'Isoler la sélection',
    showAll: 'Tout afficher',
  },

  // FileCard
  fileCard: {
    generating3D: 'Génération de la maquette 3D...',
    processingFailed: 'Échec du traitement',
    queued: 'En file d’attente',
    downloadTooltip: 'Télécharger',
    shareTooltip: 'Partager',
    editTooltip: 'Modifier',
    deleteTooltip: 'Supprimer',
    confirmDelete: 'Cliquez à nouveau pour confirmer',
    confirm: 'Confirmer ?',
    view2D: 'Voir en 2D',
    view3D: 'Voir en 3D',
    fileName: 'Nom du fichier',
    description: 'Description',
    descriptionPlaceholder: 'Ajoutez une description...',
    save: 'Enregistrer',
    cancel: 'Annuler',
  },

  // Share Modal
  shareModal: {
    shareTitle: 'Partager « {name} »',
    viewer: 'Visionneuse',
    embed: 'Intégrer',
    shareFile: 'Partager le fichier',
    viewerDesc: 'Partagez un lien vers la visionneuse. Toute personne disposant de ce lien peut consulter ou télécharger le fichier dans son navigateur, sans compte.',
    generatingLink: 'Génération du lien sécurisé...',
    tryAgain: 'Réessayer',
    copied: 'Copié !',
    copy: 'Copier',
    recipientsCanView: 'Les destinataires peuvent consulter ou télécharger le fichier directement',
    email: 'E-mail',
    whatsapp: 'WhatsApp',
    embedDesc: 'Collez ce code dans le HTML de votre site pour intégrer une visionneuse interactive :',
    generatingEmbed: 'Génération du code d’intégration...',
    directLinkDesc: 'Copiez le lien de téléchargement direct ou envoyez-le par e-mail / WhatsApp :',
  },

  // Guest (anonymous) sessions
  guest: {
    badge: 'Invité',
    saveTitle: 'Enregistrez vos fichiers',
    saveDesc: 'Vous utilisez une session invité. Connectez-vous avec Google pour conserver vos fichiers et les partager.',
    shareLocked: 'Connectez-vous pour partager',
    shareLockedDesc: 'Les liens publics et les intégrations nécessitent un compte. Vos fichiers importés seront transférés sur votre compte.',
    accountDesc: 'Session invité. Vos fichiers seront perdus si vous effacez les données du navigateur ou vous déconnectez.',
  },

  // Theme toggle
  theme: {
    system: 'Thème : système',
    light: 'Thème : clair',
    dark: 'Thème : sombre',
  },

  // Cookie Banner
  cookies: {
    message: 'Nous utilisons des cookies pour améliorer votre expérience. En utilisant Bimdrop, vous acceptez notre',
    cookiePolicy: 'politique de cookies',
    accept: 'Accepter',
  },

  // Pricing
  pricing: {
    title: 'Des tarifs simples et transparents',
    subtitle: 'Commencez gratuitement. Évoluez selon vos besoins.',
    free: 'Gratuit',
    pro: 'Pro',
    enterprise: 'Entreprise',
    forever: 'à vie',
    perMonth: '/mois',
    freeDesc: 'Idéal pour démarrer',
    proDesc: 'Pour les professionnels et les petites équipes',
    enterpriseDesc: 'Pour les organisations aux besoins avancés',
    getStarted: 'Commencer',
    comingSoon: 'Bientôt disponible',
    upgrade: 'Passer à Pro',
    processing: 'Traitement...',
    contactUs: 'Nous contacter',
    popular: 'Populaire',
    // Features
    freeF1: '10 imports de fichiers par mois',
    freeF2: 'Partage par lien, e-mail et WhatsApp',
    freeF3: 'Intégration de fichiers sur vos sites',
    freeF4: 'Gestion de fichiers de base',
    freeF5: 'Fichiers jusqu’à 100 Mo',
    proF1: '150 imports de fichiers par mois',
    proF2: 'Tout le forfait Gratuit',
    proF3: 'Fichiers jusqu’à 1 Go',
    proF4: 'Votre marque sur les intégrations',
    proF5: 'Support prioritaire',
    proF6: 'Statistiques et suivi des téléchargements',
    entF1: 'Tout le forfait Pro',
    entF2: 'Taille de fichier illimitée',
    entF3: 'SSO et gestion d’équipe',
    entF4: 'Domaine personnalisé',
    entF5: 'SLA et support dédié',
    entF6: 'Accès API',
    home: 'Accueil',
    legalCookies: 'Mentions légales et cookies',
  },

  // Legal
  legal: {
    title: 'Mentions légales et politique de cookies',
    lastUpdated: 'Dernière mise à jour : mars 2026',
  },

  // How it works page
  how: {
    fmtTekla: 'Maquettes Tekla Structures 2020+ : importez le dossier du modèle en ZIP (bêta)',
    fmtFab: 'Fichiers de fabrication : bois (BTLX) et pièces acier (DSTV NC1)',
    exportTitle: 'Exportez depuis votre logiciel',
    exportNote: 'Les noms de menus varient légèrement selon les versions.',
    exportRevit1: 'Les projets Revit 2023–2025 s’ouvrent directement : importez le .rvt (bêta).',
    exportRevit2: 'Pour la maquette complète ou d’autres versions : Fichier → Exporter → IFC.',
    exportRevit3: 'Choisissez IFC4 Reference View ou IFC 2x3 Coordination View 2.0 et importez le .ifc.',
    exportTekla1: 'Maquette : Fichier → Exporter → IFC, type d’export « Coordination view », puis importez le .ifc.',
    exportTekla2: 'Fabrication : Fabrication → Fichiers CN (DSTV). Importez les .nc1 ou un ZIP du dossier.',
    exportTekla3: 'Chaque NC1 s’ouvre comme une pièce acier avec son profil, ses perçages et son repère.',
    fmtRvt: 'Projets Revit 2023–2025, convertis dans votre navigateur (bêta)',
    fmtCad: 'CAO volumique : assemblages avec noms et couleurs',
    fmtMore: 'X, OFF, 3DS, PLY, VRML, CityJSON et plus. DWG et PDF sont stockés en téléchargement.',
    eyebrow: 'Comment ça marche',
    title: 'Du fichier au lien partagé en trois étapes',
    subtitle: 'Déposez un fichier BIM ou CAO, explorez-le en 3D dans le navigateur et envoyez un lien. Sans plugin ni installation.',
    s1Title: 'Déposez votre fichier',
    s1Desc: 'Glissez un fichier dans la zone d’import ou choisissez-le sur votre ordinateur. Vous pouvez essayer sans compte.',
    s1P1: 'IFC, DXF, GLB, OBJ, FBX, DAE, STL, 3MF, USDZ, BTLX, DWG, PDF et plus',
    s1P2: 'Jusqu’à 100 Mo en Gratuit et 1 Go en Pro',
    s1P3: 'Aucune inscription pour vos premiers fichiers',
    s2Title: 'Explorez-le en 3D',
    s2Desc: 'La maquette s’ouvre directement dans le navigateur. Tournez autour, cliquez sur un élément pour lire ses propriétés, masquez ou isolez des parties.',
    s2P1: 'Attributs et jeux de propriétés IFC',
    s2P2: 'Plans DXF en 2D, GLB, GLTF et STL en 3D',
    s2P3: 'Fichiers bois BTLX convertis en 3D automatiquement',
    s3Title: 'Partagez un lien',
    s3Desc: 'Connectez-vous avec Google pour obtenir un lien public. Tout le monde peut ouvrir la visionneuse, sans compte.',
    s3P1: 'Copiez le lien ou envoyez-le par e-mail ou WhatsApp',
    s3P2: 'Intégrez la visionneuse à votre site en un seul extrait',
    s3P3: 'Les aperçus de lien affichent une miniature de votre maquette',
    mockReady: 'Prêt',
    mockSelected: 'Sélection',
    mockSite: 'Votre site',
    accountsTitle: 'Avec ou sans compte',
    guestTitle: 'Sans compte',
    guestDesc: 'Idéal pour essayer Bimdrop avec votre propre fichier.',
    guestF1: '3 imports de 100 Mo maximum',
    guestF2: 'Visualisation en 3D et 2D',
    guestF3: 'Fichiers conservés dans ce navigateur uniquement',
    accountTitle: 'Avec un compte Google gratuit',
    accountDesc: 'Conservez vos fichiers et partagez-les.',
    accountF1: '10 imports par mois',
    accountF2: 'Liens publics et intégrations',
    accountF3: 'Vos fichiers sur tous vos appareils',
    formatsTitle: 'Formats pris en charge',
    fmtIfc: 'Maquette 3D avec propriétés',
    fmtDxf: 'Plan 2D, ou 3D s’il contient des entités 3D',
    fmtGlb: 'Modèle 3D, exports SketchUp et impression 3D compris',
    fmtBtlx: 'Données d’usinage bois, converties en 3D',
    fmtOther: 'Stockés et partagés en téléchargement',
    ctaTitle: 'Essayez avec votre propre fichier',
  },

  // Viewer workspace (toolbar, panels, saved views)
  ws: {
    frame: 'Unités et orientation',
    units: 'Unités de la maquette',
    upAxis: 'Axe vertical',
    upY: 'Y vers le haut',
    upZ: 'Z vers le haut',
    toolSelect: 'Sélectionner',
    toolMeasure: 'Mesurer',
    toolNote: 'Ajouter une note',
    toolClip: 'Coupe',
    fit: 'Ajuster la vue',
    presets: 'Vues',
    presetIso: 'Isométrique',
    presetTop: 'Dessus',
    presetFront: 'Face',
    presetBack: 'Arrière',
    presetLeft: 'Gauche',
    presetRight: 'Droite',
    projection: 'Perspective / orthogonale',
    walk: 'Mode visite',
    walkHint: 'Glissez pour regarder · ZQSD/WASD ou flèches pour avancer · Échap pour quitter',
    hide: 'Masquer',
    isolate: 'Isoler',
    showAll: 'Tout afficher',
    color: 'Couleur',
    clearColors: 'Retirer les couleurs',
    xray: 'Rayons X',
    screenshot: 'Capture',
    fullscreen: 'Plein écran',
    exitFullscreen: 'Quitter le plein écran',
    clipX: 'Coupe X',
    clipY: 'Coupe Y',
    clipZ: 'Coupe Z',
    clipFace: 'Cliquez sur une face pour couper',
    clipClear: 'Retirer les coupes',
    panel: 'Panneau',
    panelModel: 'Maquette',
    panelCategories: 'Catégories',
    panelLayers: 'Calques',
    panelViews: 'Vues',
    panelNotes: 'Notes',
    panelMeasures: 'Mesures',
    panelProperties: 'Propriétés',
    treeLoading: 'Chargement de la structure…',
    treeEmpty: 'Aucune structure disponible',
    groupsEmpty: 'Rien à afficher',
    viewsAdd: 'Enregistrer la vue actuelle',
    viewsNamePlaceholder: 'Nom de la vue',
    viewsEmpty: 'Enregistrez des points de vue pour guider ceux qui ouvrent le lien.',
    viewDefaultName: 'Vue {n}',
    notesEmpty: 'Utilisez l’outil note pour épingler des commentaires sur la maquette.',
    notePlaceholder: 'Écrivez une note…',
    noteAdd: 'Ajouter la note',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    saveEdit: 'Enregistrer',
    measuresEmpty: 'Utilisez l’outil mesure et cliquez sur deux points.',
    measureClear: 'Tout effacer',
    measureHint: 'Cliquez sur deux points pour mesurer · Échap pour annuler',
    noteHint: 'Cliquez sur la maquette pour placer une note',
    clipHint: 'Cliquez sur une face pour ajouter une coupe · faites glisser les flèches pour la déplacer',
    selectionEmpty: 'Sélectionnez un élément pour voir ses propriétés',
    focus: 'Centrer',
    save: 'Enregistrer la vue',
    saving: 'Enregistrement…',
    saved: 'Vue enregistrée',
    saveError: 'Impossible d’enregistrer la vue',
    tooBig: 'Cette vue est trop volumineuse. Retirez des éléments masqués ou des notes.',
    unsaved: 'Modifications non enregistrées',
    resetShared: 'Revenir à la vue partagée',
    discard: 'Annuler les modifications',
    ownerHint: 'Ce que vous enregistrez ici est ce que verront les personnes qui ouvrent le lien.',
    sharedBadge: 'Vue partagée',
    shortcuts: 'Raccourcis clavier',
    close: 'Fermer',
    noteBy: 'Note',
    tour: 'Visite guidée',
  },

  // Revit files (rvt-rs)
  revit: {
    reading: 'Lecture du fichier Revit…',
    converting: 'Conversion du modèle Revit en IFC…',
    localHint: 'Converti dans votre navigateur : le fichier n’est envoyé nulle part.',
    unsupportedTitle: 'Ce fichier Revit ne peut pas encore être affiché en 3D',
    unsupportedDesc: 'Revit {version}, {kind}. La vue 3D fonctionne pour les projets Revit 2023, 2024 et 2025.',
    exportHint: 'Dans Revit : Fichier → Exporter → IFC, puis importez l’IFC ici pour voir la maquette complète.',
    download: 'Télécharger l’original',
    error: 'Impossible de lire ce fichier Revit',
    betaHint: 'Converti depuis Revit dans votre navigateur avec rvt-rs. Certains éléments sont simplifiés (portes, fenêtres et mobilier peuvent apparaître comme des boîtes).',
    kind_project: 'projet',
    kind_family: 'famille',
    kind_template: 'gabarit',
    kind_unknown: 'fichier',
  },

  // SEO
  seo: {
    howTitle: 'Comment ça marche — importez, visualisez et partagez vos fichiers BIM',
    howDesc: 'Déposez un fichier Revit, IFC, STEP, DXF ou l’un des 70 types de fichiers 3D, explorez-le dans le navigateur et partagez-le par lien ou intégration. Bimdrop étape par étape.',
    landingTitle: 'Ouvrez et partagez Revit, IFC, STEP et fichiers 3D par lien',
    landingDesc:
      'Bimdrop ouvre Revit, IFC, STEP, IGES, Rhino, Tekla, DSTV, DXF, OBJ, FBX, glTF, STL et 70 types de fichiers dans le navigateur, sans rien installer. Partagez-les par lien ou intégrez une visionneuse 3D interactive.',
    pricingTitle: 'Tarifs — Forfaits Free, Pro et Enterprise',
    pricingDesc:
      'Des tarifs simples et transparents pour partager vos fichiers BIM. Commencez gratuitement avec 10 imports par mois. Passez à Pro pour des limites plus élevées, des fichiers plus volumineux et des statistiques.',
    legalTitle: 'Mentions légales et politique de cookies',
    legalDesc:
      'Mentions légales, conditions d’utilisation et politique de cookies de Bimdrop.',
  },
} as const
